var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { class: { hasHandwrittenFont: _vm.hasHandwrittenFont } },
    [
      _c("vue-progress-bar"),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("vue-toastr", { ref: "toastr" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }